import {
  tapFlashError,
  tapFlashSuccessWithCustomMessage,
} from '../generic/flash-messages';
import api from '../REST/api';
import { markUiAction } from '../utils/create-ui-action';
import { changeStatuses } from './constants';

export const withdraw = (campaignId, changeRequestId) =>
  markUiAction({
    type: withdraw.toString(),
    payload: api.patchCampaignChange(campaignId, changeRequestId, {
      status: changeStatuses.withdrawn,
    }),
  });
withdraw.toString = () => 'change-requests/withdraw';

export const review =
  (campaignId, changeRequestId, approvalId, approvalStatus) => dispatch =>
    dispatch(
      markUiAction({
        type: review.toString(),
        payload: api
          .patchCampaignChangeApproval(
            campaignId,
            changeRequestId,
            approvalId,
            {
              status: approvalStatus,
            },
          )
          .then(
            tapFlashSuccessWithCustomMessage(dispatch),
            tapFlashError(dispatch),
          ),
      }),
    );
review.toString = () => 'change-requests/review';
